/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiremitProfile.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/ediremit-profile";

export class AutogenModelEdiremitProfile<RowType extends ModelRow> extends Endpoint<RowType, RowEdiremitProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiremitProfile extends ModelRow<RowEdiremitProfileFields> {
	constructor(values?: Partial<RowEdiremitProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiremitProfileFields {
	ack_xmit_method: string;
	alt_partner_id: string;
	company_id: string;
	direction: string;
	edi_comm_id: number;
	enf_batch_cont_997: string;
	fa_threshold: number;
	func_ack_filename: string;
	func_ack_st02_frmt: string;
	func_ack_tid: number;
	func_altpartner_id: string;
	func_comm_id: number;
	func_next_batch: number;
	func_partner_id: string;
	func_use_m_batch: string;
	func_version: string;
	id: string;
	intercompany: string;
	next_batch: number;
	notes: string;
	partner_id: string;
	partner_name: string;
	process_cash_recpt: string;
	process_priority: number;
	rec_update_method: string;
	remove_func_ack: string;
	send_func_ack: string;
	send_to_company: string;
	st02_format: string;
	template_id: number;
	transaction_set: string;
	version: string;
}

